/**
 * Invisible height reserve for the navbar menu while the user's identity loads. No skeleton on
 * purpose: the menu appears once, already resolved. The box matches the profile section's
 * height (avatar + padding) so the header doesn't jump when the menu mounts.
 */
export const MainNavbarPlaceholder = () => (
  <div aria-hidden="true" className="invisible flex grow items-center justify-end lg:py-px">
    <div className="hidden lg:flex lg:py-2">
      <span className="size-10" />
    </div>
  </div>
);
